<template>
  <el-dialog title="直播详情" :append-to-body="true" :visible.sync="visible" :show-close="false" width="55%" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false">
    <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click.stop="cancelModal"><i
      class="el-dialog__close el-icon el-icon-close"></i></button>
    <el-form :model="live" size="small" :rules="rules">
      <el-form-item label="直播标题" label-width="75px" prop="title">
        <el-input v-model="live.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="讲师姓名" label-width="75px" prop="name">
        <el-input v-model="live.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="讲师简介" label-width="75px">
        <el-input type="textarea" :rows="1" v-model="live.info" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="课件分类"  label-width="75px" prop="videotypeid">
        <el-select v-model="live.videotypeid" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="讲师照片" label-width="75px">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :http-request="uploadLecturerPhoto"
          :before-upload="beforeUpload"
          :file-list="fileList"
          list-type="picture">
          <div class="el-upload__text"><i class="el-icon-upload" style="font-size: 18px"></i><span>上传</span></div>
        </el-upload>
      </el-form-item>
      <el-form-item label="直播内容" label-width="75px" prop="content">
        <el-input type="textarea" :rows="1" v-model="live.content" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="直播时段" label-width="75px" prop="startTime">
        <el-date-picker
          style="width: 185px"
          v-model="live.startTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间">
        </el-date-picker>&nbsp;-&nbsp;
        <el-date-picker
          style="width: 185px"
          v-model="live.endTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
    <el-form-item label="录制视频" label-width="75px" v-if="values !== null">
      <div v-if="live.files.length > 0 && (live.liveStatus === '2' || live.liveStatus === '9')">
        <!--<div v-for="item in live.files" style="width:170px;position: relative;float: left">-->
          <!--<video  controls="controls" :src="[url + item.originalAddresss]" class="avatar">-->
          <!--</video>-->
        <!--</div>-->
        <el-table :data="live.files" style="width: 100%" :row-style="{height:'0px'}" :cell-style="{padding:'5px'}">
          <el-table-column align="center" label="视频地址(点击可下载)" min-width="300">
            <template slot-scope="scope">
              <el-link type="info" :href="url + scope.row.originalAddresss" underline="">{{scope.row.originalAddresss}}</el-link>
            </template>
          </el-table-column>
          <el-table-column align="center" label="视频长度" min-width="100">
            <template slot-scope="scope">
              {{scope.row.videoLength}}秒
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="180">
            <template slot-scope="scope">
              <el-link v-if="scope.row.status === '1'" :underline="false" type="danger" @click="jinBo(scope.row)">已禁播</el-link>
              <el-link v-else type="success" :underline="false" @click="jinBo(scope.row)">可播</el-link>
            </template>
          </el-table-column>
        </el-table>
        <!--<p v-for="v in live.files" style="margin: 0;">-->
          <!--<el-link type="info" :href="url + v.originalAddresss" underline="">{{v.originalAddresss}}</el-link>-->
          <!--&nbsp;-->
          <!--<span>视频长度：{{v.videoLength}}秒</span>-->
          <!--&nbsp;-->
          <!--<span>-->
              <!--<el-switch-->
                <!--v-model="v.status"-->
                <!--active-color="#13ce66"-->
                <!--inactive-color="#ff4949"-->
                <!--active-value="0"-->
                <!--inactive-value="1"-->
                <!--@change="changeSwitch(v)">-->
            <!--</el-switch>-->
          <!--</span>-->
        <!--</p>-->
      </div>
      <div v-if="live.liveStatus !== '2' && live.liveStatus !== '9'">
        直播未结束/已取消，暂无录制视频
      </div>
    </el-form-item>
    </el-form>
    <el-form :model="attachment" size="small">
      <el-form-item label="附件" label-width="50px">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-change="handleChange"
          :on-remove="attRemove"
          :before-upload="beforeupload"
          :file-list="attList">
          <div class="el-upload__text"><i class="el-icon-upload" style="font-size: 18px"></i><span>上传</span></div>
        </el-upload>
      </el-form-item>
      <el-form-item label="能否下载"  label-width="75px">
        <template>
          <el-radio v-model="attachment.download" label="0">是</el-radio>
          <el-radio v-model="attachment.download" label="1">否</el-radio>
        </template>
      </el-form-item>
    </el-form>
    <!--<template>-->
      <!--<el-tabs v-model="activeName" @tab-click="handleClick">-->
        <!--<el-tab-pane label="直播时间段1" name="first">-->
          <!--<el-form :model="liveTime1" size="small">-->
            <!--<el-form-item label="段名称" label-width="70px">-->
              <!--<el-input v-model="liveTime1.name" autocomplete="off" style="width: 260px"></el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="直播时段" label-width="70px">-->
              <!--<el-date-picker-->
                <!--style="width: 185px"-->
                <!--v-model="liveTime1.startTime"-->
                <!--type="datetime"-->
                <!--placeholder="选择日期时间">-->
              <!--</el-date-picker>&nbsp;-&nbsp;-->
              <!--<el-date-picker-->
                <!--style="width: 185px"-->
                <!--v-model="liveTime1.endTime"-->
                <!--type="datetime"-->
                <!--placeholder="选择日期时间">-->
              <!--</el-date-picker>-->
            <!--</el-form-item>-->
            <!--&lt;!&ndash;暂不需要手动上传直播视频&ndash;&gt;-->
            <!--&lt;!&ndash;<el-form-item label="视频文件" label-width="70px">&ndash;&gt;-->
              <!--&lt;!&ndash;<el-upload&ndash;&gt;-->
                <!--&lt;!&ndash;action="https://jsonplaceholder.typicode.com/posts/"&ndash;&gt;-->
                <!--&lt;!&ndash;multiple>&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="el-upload__text"><i class="el-icon-upload" style="font-size: 18px"></i><span>上传</span></div>&ndash;&gt;-->
              <!--&lt;!&ndash;</el-upload>&ndash;&gt;-->
            <!--&lt;!&ndash;</el-form-item>&ndash;&gt;-->
          <!--</el-form>-->
        <!--</el-tab-pane>-->
        <!--<el-tab-pane label="直播时间段2" name="second">-->
          <!--<el-form :model="liveTime2" size="small">-->
            <!--<el-form-item label="段名称" label-width="70px">-->
              <!--<el-input v-model="liveTime2.name" autocomplete="off" style="width: 260px"></el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="直播时段" label-width="70px">-->
              <!--<el-date-picker-->
                <!--style="width: 185px"-->
                <!--v-model="liveTime2.startTime"-->
                <!--type="datetime"-->
                <!--placeholder="选择日期时间">-->
              <!--</el-date-picker>&nbsp;-&nbsp;-->
              <!--<el-date-picker-->
                <!--style="width: 185px"-->
                <!--v-model="liveTime2.endTime"-->
                <!--type="datetime"-->
                <!--placeholder="选择日期时间">-->
              <!--</el-date-picker>-->
            <!--</el-form-item>-->
            <!--<el-form-item>-->
              <!--<span v-if="liveTime2.startTime !== null">-->
               <!--<el-button  @click="delTime(liveTime2.id)" type="primary">删除此时间段</el-button>-->
              <!--</span>-->
            <!--</el-form-item>-->
          <!--</el-form>-->
        <!--</el-tab-pane>-->
        <!--<el-tab-pane label="直播时间段3" name="third">-->
          <!--<el-form :model="liveTime3" size="small">-->
            <!--<el-form-item label="段名称" label-width="70px">-->
              <!--<el-input v-model="liveTime3.name" autocomplete="off" style="width: 260px"></el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="直播时段" label-width="70px">-->
              <!--<el-date-picker-->
                <!--style="width: 185px"-->
                <!--v-model="liveTime3.startTime"-->
                <!--type="datetime"-->
                <!--placeholder="选择日期时间">-->
              <!--</el-date-picker>&nbsp;-&nbsp;-->
              <!--<el-date-picker-->
                <!--style="width: 185px"-->
                <!--v-model="liveTime3.endTime"-->
                <!--type="datetime"-->
                <!--placeholder="选择日期时间">-->
              <!--</el-date-picker>-->
            <!--</el-form-item>-->
            <!--<el-form-item>-->
              <!--<span v-if="liveTime3.startTime !== null">-->
               <!--<el-button  @click="delTime(liveTime3.id)" type="primary">删除此时间段</el-button>-->
              <!--</span>-->
            <!--</el-form-item>-->
          <!--</el-form>-->
        <!--</el-tab-pane>-->
        <!--<el-tab-pane label="直播时间段4" name="fourth">-->
          <!--<el-form :model="liveTime4" size="small">-->
            <!--<el-form-item label="段名称" label-width="70px">-->
              <!--<el-input v-model="liveTime4.name" autocomplete="off" style="width: 260px"></el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="直播时段" label-width="70px">-->
              <!--<el-date-picker-->
                <!--style="width: 185px"-->
                <!--v-model="liveTime4.startTime"-->
                <!--type="datetime"-->
                <!--placeholder="选择日期时间">-->
              <!--</el-date-picker>&nbsp;-&nbsp;-->
              <!--<el-date-picker-->
                <!--style="width: 185px"-->
                <!--v-model="liveTime4.endTime"-->
                <!--type="datetime"-->
                <!--placeholder="选择日期时间">-->
              <!--</el-date-picker>-->
            <!--</el-form-item>-->
            <!--<el-form-item>-->
              <!--<span v-if="liveTime4.startTime !== null">-->
               <!--<el-button  @click="delTime(liveTime4.id)" type="primary">删除此时间段</el-button>-->
              <!--</span>-->
            <!--</el-form-item>-->
          <!--</el-form>-->
        <!--</el-tab-pane>-->
      <!--</el-tabs>-->
    <!--</template>-->
    <div slot="footer" class="dialog-footer">
      <el-button v-if="loading" type="primary" :loading="true">保存中</el-button>
      <el-button v-else type="primary" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import live from '@/api/live'
import attachment from '@/api/attachment'
import video from '@/api/video'
import courseware from '@/api/courseware'
import axios from 'axios'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    values: {
      type: Number,
      required: false,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      options:[],
      fileList: [],
      attList: [],
      param: '',
      photoParam: '',
      file: null,
      fileName: '',
      url: 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/',
      importUrl:'/video/file/upload',
      // 直播
      live: {
        id: null,
        title: '',
        name: '',
        info: '',
        photo: '',
        videotypeid: null,
        img: '',
        content: '',
        startTime: null,
        endTime: null,
        liveStatus: '',
        status: '1',
        files: []
      },
      rules: {
        title: [
          {required: true, message: '请输入直播标题', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '请输入讲师姓名', trigger: 'blur'},
        ],
        content: [
          {required: true, message: '请输入直播内容', trigger: 'blur'},
        ],
        startTime: [
          {required: true, trigger: 'blur'},
        ],
        videotypeid: [
          {required: true, message: '请选择视频分类', trigger: 'change'},
        ]
      },
      // 附件
      attachment: {
        id: null,
        liveId: null,
        name: '',
        file: '',
        download: '0'
      },
      activeName: 'first'
    }
  },
  methods: {
    initForm () {
      this.live = {
      }
      if (this.$refs.live) {
        this.$refs.live.resetFields()
      }
    },
    cancelModal () {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit('update:visible', false)
    },
    reload () {
      if (this.values !== null) {
        // 根据liveid查找live liveTime 和附件
        live.load({id: this.values}).then(res => {
          // console.log(res.data.data)
          this.live = res.data.data
          if (this.live.photo!=null && this.live.photo!=='') {
            this.fileList = []
            let upLoadImg = {
              name: this.live.photo,
              url: 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/' + this.live.photo
            }
            this.fileList.push(upLoadImg)
          }
        })
        // 附件
        attachment.find({liveId: this.values, type: 'L'}).then(res => {
          if (res.data.code === 0){
            this.attachment.download= res.data.data[0].download
            // console.log(this.attachment)
            let list = res.data.data
            this.attList = []
            list.forEach((item, i, arr) => {
              let upLoadImg = {
                id: item.id,
                name: item.name,
                url: 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/' + item.path
              }
              this.attList.push(upLoadImg)
            })
          }
        })
        // // 时间段 列表
        // live.findTime({liveId: this.values}).then(res => {
        //   this.timeList = res.data.data
        //   console.log(this.timeList)
        //   let length = this.timeList.length
        //   if (length === 1){
        //     this.liveTime1 = this.timeList[0]
        //   }
        //   if (length === 2){
        //     this.liveTime1 = this.timeList[0]
        //     this.liveTime2 = this.timeList[1]
        //   }
        //   if (length === 3){
        //     this.liveTime1 = this.timeList[0]
        //     this.liveTime2 = this.timeList[1]
        //     this.liveTime3 = this.timeList[2]
        //   }
        //   if (length === 4){
        //     this.liveTime1 = this.timeList[0]
        //     this.liveTime2 = this.timeList[1]
        //     this.liveTime3 = this.timeList[2]
        //     this.liveTime4 = this.timeList[3]
        //   }
        // })
        // 附件列表
        // live.load({id: this.values}).then(res => {
        //   this.live = res.data.data
        //   console.log('直播详情：')
        //   console.log(this.live)
        // })
      }
    },
    // 删除时间段
    // delTime (timeId) {
    //   live.delTime({id: timeId}).then(res => {
    //     this.$message.info(res.data.message)
    //   })
    // },
    // 获取课件所属分类
    getCoursewareType () {
      courseware.findAllType({name: ''}).then(res => {
        if (res.data.code === 0){
          this.options = []
          res.data.data.forEach(item => {
            let obj = {
              label: item.name,
              value: item.id
            }
            this.options.push(obj)
          })
        }
      })
    },
    // 禁播录播视频
    jinBo (row) {
      let str;
      let sta;
      if (row.status === '1'){
        str = '确定设置该视频为可播放吗?'
        sta = '0'
      } else if(row.status === '0'){
        str = '确定将此视频禁播吗?'
        sta = '1'
      }
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.status = sta
        video.saveVideoPath(row).then(res => {
          this.$message.warning(res.data.message)
        })
      }).catch(() => {
      });
    },
    save () {
      // console.log(this.live)
      // 新增
      this.loading = true
      if (this.live.id==null){
        if (this.fileName !== ''){
          live.save(this.live).then(res => {
            this.loading = false
            if (res.data.code===0){
              //保存附件
              this.attList.forEach(file => {
                this.param.append('file', file.raw, file.raw.name)
              })
              this.param.append('type', 'L')
              this.param.append('download', this.attachment.download)
              this.param.append('liveId', res.data.data)
              attachment.upload(this.param).then(resust => {
                if (resust.data.code===0){
                  this.$message.success('保存成功')
                  this.$emit('update:visible', false)
                  this.$emit('callFather')
                }else {
                  this.$message.info('保存失败')
                }
              })
            }
          })
        }else {
          live.save(this.live).then(res => {
            this.loading = false
            this.$message.info(res.data.message)
            if (res.data.code===0){
              this.$emit('update:visible', false)
              this.$emit('callFather')
            }
          })
        }
      } else {
        // 修改
        if (this.fileName !== ''){
          live.save(this.live).then(res => {
            this.loading = false
            if (res.data.code===0){
              //保存附件
              this.attList.forEach(file => {
                if (file.hasOwnProperty('raw')) {
                  this.param.append('file', file.raw)
                }
              })
              this.param.append('type', 'L')
              this.param.append('download', this.attachment.download)
              this.param.append('liveId', this.live.id)
              attachment.upload(this.param).then(resust => {
                if (resust.data.code===0){
                  this.$message.success('保存成功')
                  this.$emit('update:visible', false)
                  this.$emit('callFather')
                }else {
                  this.$message.info('保存失败')
                }
              })
            }
          })
        }else {
          live.save(this.live).then(res => {
            this.loading = false
            this.$message.info(res.data.message)
            if (res.data.code===0){
              this.$emit('update:visible', false)
              this.$emit('callFather')
            }
          })
        }
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    beforeUpload(file) {
      // console.log(file);
      //重新写一个表单上传的方法
      this.photoParam = new FormData();
      this.photoParam.append('file', file, file.name)
      // return false;
    },
    uploadLecturerPhoto () {
      video.uploadPhoto(this.photoParam).then(res => {
        if (res.data.code===0){
          this.$message.success('图片保存成功')
          let photoUrl = res.data.data
          photoUrl = photoUrl.replace(/\\/g,'/')
          var index = photoUrl.lastIndexOf("/");
          let name = photoUrl.substring(index+1,photoUrl.length);
          let upLoadImg = {
            name: name,
            url: 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/' + photoUrl
          }
          this.fileList.push(upLoadImg)
          this.live.photo = photoUrl
        }else {
          this.$message.info('图片保存失败')
        }
      })
    },
    // 删除附件
    attRemove(file, attList) {
      // console.log(file, attList);
      // 从数据库中删除
      if (file.hasOwnProperty('id')){
        attachment.del({id: file.id}).then(res => {
          this.$message.info(res.data.message)
        })
      }
    },
    handleChange(file, fileList) {
      // console.log(file.raw);
      this.attList = fileList.slice(-3);
    },
    //阻止upload的自己上传，进行再操作
    beforeupload(file) {
      // console.log(file);
      //重新写一个表单上传的方法
      this.param = new FormData();
      this.fileName = file.name
      return false;
    },
    //覆盖默认的上传行为
    httprequest() {
    }
  },
  created () {
    this.getCoursewareType()
    this.reload()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/video/live/Live.vue